import React, {Component, Suspense} from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import NameComponent from './NameComponent';
import { AppFooter } from '@coreui/react';
import DefaultFooter from '../containers/DefaultLayout/DefaultFooter';
import {connect} from 'react-redux'
import { QueryInitialize_ACTION } from '../Actions/LogisticActions';

var typingTimer;
var ClosingTimer;
var InitializeTimer;

class ModalComponent extends Component {
    constructor(props){
        super(props)
        
        this.state = {
            Close: false
        }

    }

    loading = () => <div className="animated fadeIn pt-1 text-center">Loading...</div>

    render(){
        if(this.props.AddedSuccessfuly){
            typingTimer = setTimeout(() => {
                this.props.Initialize()

            }, 1600);
        }

        return(
            <Modal isOpen = {!this.state.Close && this.props.isOpen} size = {this.props.size || 'lg'}>
               {this.props.ModalHeader ?<ModalHeader closeButton>
                    <NameComponent text = {this.props.ModalHeader} />
                </ModalHeader> : <div/>}
                <ModalBody>
                    {this.props.children}
                </ModalBody>
                {!this.props.NoActionLog ? <div style = {{height:60, width: '97%',marginLeft:5 }}> 
                    <h5 style = {{color:'#0099cc',borderBottom:1, borderBottomStyle:'dotted', borderBottomColor:'gray'}}>Action Log</h5>
                    {this.props.Error ? 
                                    <div>
                                        <h4 style = {{color:'red', fontWeight:'bold'}}>{this.props.Error}</h4>
                    </div> : <div />}
                    {this.props.AddedSuccessfuly ? 
                                    <div>
                                        <h4 style = {{color:'green', fontWeight:'bold'}}>Success !</h4>
                                </div> : <div />}
                </div> : <div/>}
            </Modal>
        )
    }
}

function MapStateToProps(state) {
    return {
        AddedSuccessfuly: state.Query.AddedSuccessfuly,
        Error: state.Query.GeneralError,
  }
  }
  
  const MapDispatchToProps = (dispatch) => {
    return {
        Initialize: () => {dispatch(QueryInitialize_ACTION())},
    }
  }
  
  export default connect(MapStateToProps, MapDispatchToProps)(ModalComponent)